import { Component } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import ProductsList from './products-list';
import ProductSearchComponent from '../../../../common/search/simple-search-component';
import PageTitle from '../../../../common/page-title/index';
import ArrowButton from '../../../../common/button-arrow';
import {getProducts} from '../../../../../actions/products';

import '../../common/styles.css';

class Products extends Component {
  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };
  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getProducts(query));
  };
  handleClear = () => {
    this.setState({query: ''}, this.handleSearch);
  };

  constructor(props) {
    super(props);

    this.state = {
      query: ''
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch({type: 'CLEAR_EDIT_PRODUCT'});
    this.props.dispatch(getProducts());
  }

  render() {
    return (
      <Container fluid className="products accordion">
        <PageTitle>
          Products
        </PageTitle>
        <Link to="/admin/products/new">
          <ArrowButton
            arrow={false}
            className="add-product"
            color="red"
            permissions={{
              action: 'new',
              subjectClass: 'Product'
            }}
            submit={false}
          >
            Add product
          </ArrowButton>
        </Link>

        <ProductSearchComponent
          onClear={this.handleClear}
          onInputChange={this.handleInputChange}
          onSearch={this.handleSearch}
          searchValue={this.state.query}
        />
        <ProductsList
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          products={this.props.products}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  products: state.products.products,
  fetched: state.products.fetched,
  fetching: state.products.fetching,
});

export default connect(mapStateToProps)(Products);
